import { render, staticRenderFns } from "./EmSppRequisitionSprList.vue?vue&type=template&id=8e2e5978&"
import script from "./EmSppRequisitionSprList.vue?vue&type=script&lang=js&"
export * from "./EmSppRequisitionSprList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports